import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const inp = "mt-1 w-full rounded-xl border border-[#E3DED4] bg-white px-3 py-2 text-sm outline-none focus:border-[#45423C]";

export function HireDialog({ line, onOpenChange, onConfirm, busy }) {
  const [name, setName] = useState("");
  useEffect(() => { if (line) { setName(""); } }, [line]);
  return (
    <Dialog open={!!line} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="hire-dialog">
        <DialogHeader>
          <DialogTitle>Πρόσληψη για τη θέση «{line?.name}»</DialogTitle>
          <DialogDescription>
            Δημιουργείται καρτέλα υπαλλήλου με τμήμα, ρόλο, μισθό, μήνες, στέγαση/σίτιση και TAF/TRIBE της θέσης. Η γραμμή του προϋπολογισμού παίρνει το όνομα και τον κωδικό του και αποθηκεύεται.
          </DialogDescription>
        </DialogHeader>
        <label className="block">
          <span className="text-[10px] uppercase tracking-wider text-[#6F6A60] font-semibold">Ονοματεπώνυμο υπαλλήλου</span>
          <input data-testid="hire-name" value={name} onChange={(e) => setName(e.target.value)} className={inp} autoFocus />
        </label>
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" data-testid="hire-cancel" onClick={() => onOpenChange(false)} className="rounded-xl px-4 py-2.5 text-sm text-[#6F6A60]">Άκυρο</button>
          <button type="button" data-testid="hire-confirm" disabled={!name.trim() || busy} onClick={() => onConfirm(name.trim())}
            className="rounded-xl bg-[#6E7A63] text-white px-4 py-2.5 text-sm font-semibold disabled:opacity-50">{busy ? "Δημιουργία…" : "Πρόσληψη"}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
